import {Component, OnInit} from '@angular/core';
import {AlertService} from '../../services/alert.service';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    standalone: false
})
export class AlertComponent implements OnInit {

  constructor(public _Alert: AlertService) {
  }

  ngOnInit() {
  }

}
